import React, { useState } from "react";
import Select from "react-select";
import { Spinner } from 'react-bootstrap';

const SelectDropdowns = ({
  options,
  value,
  placeholder,
  onOptionSelect,
  disabled,
  type,
  id,
  loading
}) => {
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      height: "34px",
      minHeight: "34px",
      display: "flex",
      fontSize: 12,
      textAlign: "left",
      color: "rgba(0,0,0,0.50)",
      borderColor: "#E6E6E6!important",
      boxShadow: "none",
    }),
    singleValue: (provided, state) => {
      const color = state.data.value;
      return {
        ...provided,
        display: "flex",
        alignItems: "center",
        ":before": {
          content: '""',
          display: "inline-block",
          width: "8px",
          height: "8px",
          borderRadius: "50%",
          backgroundColor: color,
          marginRight: "5px",
        },
      };
    },
    indicatorSeparator: () => ({
      display: "none",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: 6,
    }),
    menu: (provided) => ({
      ...provided,
      fontSize: "12px",
    }),
    option: (provided, state) => {
      const color = state.data.value;
      return {
        ...provided,
        display: "flex",
        alignItems: "center",
        color: localStorage.getItem("theme") == "darks" ? "white" : "black",
        backgroundColor: state.isFocused ? "#4F8CCA" : "transparent",
        ":before": {
          content: '""',
          display: "inline-block",
          width: "8px",
          height: "8px",
          borderRadius: "50%",
          backgroundColor: color,
          marginRight: "5px",
        },
      };
    },
  };
  // const ColorSelect = () => {
  //   const [selectedColor, setSelectedColor] = useState(null);

  //   return (
  //     <Select
  //       options={colors}
  //       styles={customStyles}
  //       onChange={setSelectedColor}
  //       value={selectedColor}
  //       placeholder="Select a Finish"
  //       className="selectdropdown"
  //       isSearchable={false}
  //     />
  //   );
  // };
  const SimpleSelect = ({
    options,
    value,
    placeholder,
    disabled,
    onOptionSelect,
    id,
    loading
  }) => {
    const [selectedOption, setSelectedOption] = useState(null);
    // console.log('SimpleSelect options:', options, 'value:', value);
    const handleChange = (selectedOption) => {
      setSelectedOption(selectedOption);
      if (onOptionSelect) {
        onOptionSelect(selectedOption, type, id); // Call the passed function
      }
    };

    return (
      <div style={{ position: 'relative' }}>
        <Select
          options={options}
          value={options.find((option) => option.value === value) || null}
          onChange={handleChange}
          isDisabled={disabled || loading}
          placeholder={placeholder}
          className="selectdropdown"
          styles={customStyles}
          isSearchable={false}
        />
        {loading && (
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'rgba(255,255,255,0.5)',
            zIndex: 2
          }}>
            <Spinner animation="border" size="sm" />
          </div>
        )}
      </div>
    );
  };
  return (
    <SimpleSelect
      options={options}
      value={value}
      disabled={disabled}
      placeholder={placeholder}
      onOptionSelect={onOptionSelect}
      type={type}
      id={id}
      loading={!!loading}
    />
  );
};
export default SelectDropdowns;
